"use strict";

$(document).ready(function () {

  var currentPage = function currentPage() {
    var page_array = window.location.href.split("/");
    return page_array.filter(Boolean)[4];
  };

  var navBar = $("#navbar-lps a");
  var loaderContainer = $("#loader_container");
  var $currentItem = void 0;
  var $page = 0;
  var $loader = $('.jc-loader');
  var $finished = false;

  $loader.addClass('d-none');
  loaderContainer.addClass('d-none');

  navBar.on('click', function (event) {
    event.preventDefault();
    $page = 0;
    $loader.addClass('d-none');
    $finished = false;
  });

  window.addEventListener('scroll', function () {
    if (!loaderContainer.is(":visible")) {
      $currentItem = slugify($("#navbar-lps .active").text());
      if ($loader[0].classList.contains('d-none') && !$finished && isBottomVisible()) {
        // Adicionar condição para impedir de buscar mais itens caso tenha chegado no limite
        $loader.removeClass('d-none');
        $page++;
        getItems();
      }
    }
  });

  var getItems = function getItems() {
    $.ajax({
      url: ajaxHandler.url,
      dataType: 'html',
      type: 'GET',
      data: {
        action: 'jc_ajax_get_lp_catalog',
        offset: $page,
        taxonomy: currentPage(),
        item: $currentItem,
        infinity_scroll: true
      },
      complete: function complete() {
        $loader.addClass('d-none');
      },
      success: function success(response) {
        if ($(response).text().trim().length === 0) {
          $finished = true;
        } else {
          $('#lp-content').append(response);
        }
      }
    });
  };

  var isBottomVisible = function isBottomVisible() {
    var visible = document.documentElement.clientHeight;
    var pageHeight = document.documentElement.scrollHeight - $('footer')[0].offsetHeight;
    return visible + window.scrollY >= pageHeight;
  };

  function slugify(text) {
    return text.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/ /g, '-').replace(/[^\w-]+/g, '');
  }
});